import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EApprovalStatus } from 'src/app/models/approval.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'que-approval-status',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './approval-status.component.html',
    styleUrls: ['./approval-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalStatusComponent {
  @Input() status?: EApprovalStatus;
  enumQStatus = EApprovalStatus;

}
